<template>
  <van-swipe class="mall-banner" autoplay="5000" indicator-color="#fff" width="100%" v-if="data && data.length > 0">
    <van-swipe-item v-for="(item, index) in data" :key="index">
      <slot :item="item" :index="index"></slot>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  name: 'MallBanner',

  props: {
    data: {
      type: [Array, Object],
      default() {
        return [];
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mall-banner {
  height: 100%;

  &::v-deep {
    .van-swipe-item {
      a {
        display: block;
        height: 100%;
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }
    }

    .van-swipe__indicators {
      bottom: .106667rem;

      .van-swipe__indicator {
        width: .16rem;
        height: .08rem;
        background: #fff;
        border-radius: 0.5px;
        opacity: 0.4;

        &.van-swipe__indicator--active {
          width: .24rem;
          opacity: 1;
        }

        &:not(:last-child) {
          margin-right: .053333rem;
        }
      }
    }
  }
}
</style>
